import notification from './../../notification'

export default {
    computed: {
      agreements() {
        return this.$store.state.agreements.agreements
      },
    },
    created () {
      this.getAgreements()
    },
    methods: {
      getAgreements() {
          this.$vs.loading()
          this.$store.dispatch('agreements/getAgreements')
            .then((response) => {
            })
            .catch(error => {
              this.$vs.notify(notification.error(error.message))
            })
          .finally(() => {
            this.$vs.loading.close()
          })
      }
    }
}